import { Icon, Text, Tag } from "@ttc3k/trekker";
import { Box, Flex } from "styled-system/jsx";
import { CheckCircleSolid, Clock, XmarkCircle } from "iconoir-react";

type OrderCardProps = {
  orderId: string;
  title: string;
  purchaserName?: string;
  subtitle?: string;
  dateStr?: string;
  isCancelled?: boolean;
  isPending?: boolean;
  cancelledLabel: string;
  confirmedLabel: string;
  pendingLabel?: string;
  onClick?: () => void;
};

export const OrderCard = ({
  orderId,
  title,
  purchaserName,
  subtitle,
  dateStr,
  isCancelled = false,
  isPending = false,
  cancelledLabel,
  confirmedLabel,
  pendingLabel,
  onClick,
}: OrderCardProps) => {
  const statusIcon = isCancelled
    ? XmarkCircle
    : isPending
      ? Clock
      : CheckCircleSolid;
  const statusColor = isCancelled
    ? "icon.error.mid"
    : isPending
      ? "icon.warning.mid"
      : "icon.success.mid";
  const tagVisual = isCancelled
    ? "destructive"
    : isPending
      ? "warning"
      : "success";
  const tagLabel = isCancelled
    ? cancelledLabel
    : isPending
      ? (pendingLabel ?? confirmedLabel)
      : confirmedLabel;

  return (
    <Box
      bg="white"
      border="1px solid"
      borderColor="border.light"
      borderRadius="200"
      p="300"
      cursor={onClick ? "pointer" : undefined}
      _hover={onClick ? { borderColor: "border.mid" } : undefined}
      onClick={onClick}
    >
      <Flex justifyContent="space-between" alignItems="center">
        <Flex alignItems="flex-start" gap="150">
          <Box mt="2px" flexShrink={0}>
            <Icon
              Element={statusIcon}
              color={statusColor}
              size="sm"
            />
          </Box>
          <Flex flexDir="column">
            <Text visual="bodySemiBold" color="text.dark">
              {title}
            </Text>
            <Text visual="smallRegular" color="text.light">
              #{orderId}
            </Text>
            {purchaserName && (
              <Text visual="smallRegular" color="text.mid">
                {purchaserName}
              </Text>
            )}
            {subtitle && (
              <Text visual="smallRegular" color="text.mid">
                {subtitle}
              </Text>
            )}
            {dateStr && (
              <Text visual="smallRegular" color="text.light">
                {dateStr}
              </Text>
            )}
          </Flex>
        </Flex>
        <Tag
          visual={tagVisual}
          mode="light"
        >
          {tagLabel}
        </Tag>
      </Flex>
    </Box>
  );
};
